import React, { useCallback, useEffect, useState } from "react";
import DirtyFormInitializer from "./dirty/DirtyFormInitializer";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import useRecaptcha from "../common/forms/useRecaptcha";

export default function Initializers() {
	const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
	const { onSetRecaptchaToken } = useRecaptcha();

	const onVerify = useCallback((token: string) => {
		token && onSetRecaptchaToken(token);
	}, []);

	const onRefreshRecaptcha = () => {
		setRefreshReCaptcha((r) => !r);
	};

	// Refresh recaptcha token
	useEffect(() => {
		const intervalCall = setInterval(() => {
			onRefreshRecaptcha();
		}, 100000);
		return () => {
			clearInterval(intervalCall);
		};
	}, []);

	return (
		<>
			<DirtyFormInitializer onLeavePage={onRefreshRecaptcha} />
			<GoogleReCaptcha
				onVerify={onVerify}
				refreshReCaptcha={refreshReCaptcha}
			/>
		</>
	);
}
